import { useState, useEffect } from 'react';

type Slide = {
  title: string;
  description: string;
};

const slides: Slide[] = [
  {
    title: 'Application',
    description:
      'Desktop and Mobile Application for homes and Schools — bringing interactive learning tools right to your fingertips.',
  },
  {
    title: 'Edutech Directory',
    description:
      'Our blog contains educational resources for parents and educators — connecting you to the best resources.',
  },
  {
    title: 'AI in Tech Consultancy',
    description:
      'Our AI Consultancy provides solutions for Automated Student Assessments and scripts marking — leveraging artificial intelligence to streamline education.',
  },
];

const ProductSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Slowed down to 5 seconds per slide

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="product-slider" aria-label="Our Products and Services">
      <h2 className="product-slider__title">Our Products and Services</h2>
      <div className="product-slider__container">
        <div
          className="product-slider__track"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {slides.map((slide, index) => (
            <div key={index} className="product-slider__slide">
              <h3>{slide.title}</h3>
              <p>{slide.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="product-slider__dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`product-slider__dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => setCurrentSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default ProductSlider;
